export const filterOption = (
  input: string,
  option: { label?: string } | undefined
) => {
  if (option && typeof option.label === "string") {
    const inputLowerCase = input.toLowerCase();
    const labelLowerCase = option.label.toLowerCase();
    return (
      labelLowerCase.includes(inputLowerCase) ||
      option.label.includes(input) || // original input
      option.label
        .toLowerCase()
        .includes(
          inputLowerCase.charAt(0).toUpperCase() + inputLowerCase.slice(1)
        )
    );
  }
  return false;
};

export const filterSort = (
  optionA: { label?: string },
  optionB: { label?: string }
) => {
  if (
    typeof optionA?.label === "string" &&
    typeof optionB?.label === "string"
  ) {
    return optionA.label
      .toLowerCase()
      .localeCompare(optionB.label.toLowerCase());
  }
  return 0;
};
